/**
 * Created by lu on 2017/10/6.
 */
var io = require('./io');
module.exports = function (inOpts) {
    inOpts.url = io.uploadUrl;
    inOpts.cmd='base/uploadImage';
    io.ajax(inOpts);
};


//////////////////
// WEBPACK FOOTER
// ../src/js/io/product/uploadImage.js
// module id = 86
// module chunks = 3 4 8 19 29